import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import form_data from "./formData";

const feiyongbaoxiaoApi = createApi({
    reducerPath: 'feiyongbaoxiaoApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/x/fyb'        
    }),
    tagTypes:['hangyeType',],
    endpoints(build) {
        return {            
            //新增行业
            hangyeTypeAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/hangyeTypeAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['hangyeType'],
            }),         
            //修改保存行业
            hangyeTypeUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/hangyeTypeUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['hangyeType'],
            }),         
            //查询行业
            hangyeTypeList: build.query({
                query(user) {                    
                    return {
                        url: '/hangyeTypeList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['hangyeType'],
            }),         
            //修改行业
            hangyeTypeUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/hangyeTypeUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['hangyeType'],
            }),         
            //新增企业类型
            qiyeTypeAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/qiyeTypeAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['qiyeType'],
            }),         
            //修改保存企业类型
            qiyeTypeUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/qiyeTypeUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['qiyeType'],
            }),         
            //查询企业类型
            qiyeTypeList: build.query({
                query(user) {                    
                    return {
                        url: '/qiyeTypeList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['qiyeType'],
            }),         
            //修改企业类型
            qiyeTypeUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/qiyeTypeUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['qiyeType'],
            }),         
            //新增企业
            fyqiyeAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/qiyeAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['qiye'],
            }),         
            //修改保存企业
            fyqiyeUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/qiyeUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['qiye'],
            }),         
            //查询企业
            fyqt: build.query({
                query(user) {                    
                    return {
                        url: '/qiyeList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['qiye'],
            }),         
            //修改企业
            fyqiyeUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/qiyeUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['qiye'],
            }),         
            //新增企业用户
            fyyonghuAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/yonghuAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['yonghu'],
            }),         
            //修改保存企业用户
            fyyonghuUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/yonghuUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['yonghu'],
            }),         
            //查询企业用户
            fyyonghuList: build.query({
                query(user) {                    
                    return {
                        url: '/yonghuList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['yonghu'],
            }),         
            //修改企业用户
            fyyonghuUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/yonghuUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['yonghu'],
            }),         
            //获取企业用户
            fygetyonghuList: build.query({
                query(user) {                    
                    return {
                        url: '/getyonghuList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['yonghu'],
            }),         
            //新增商品
            shangpinAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpinAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpin'],
            }),         
            //修改保存商品
            shangpinUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpinUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpin'],
            }),         
            //查询商品
            shangpinList: build.query({
                query(user) {                    
                    return {
                        url: '/shangpinList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shangpin'],
            }),         
            //修改商品
            shangpinUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/shangpinUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shangpin'],
            }),         
            //新增商品规格
            shangpinguigeAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpinguigeAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpinguige'],
            }),         
            //修改保存商品规格
            shangpinguigeUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpinguigeUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpinguige'],
            }),         
            //查询商品规格
            shangpinguigeList: build.query({
                query(user) {                    
                    return {
                        url: '/shangpinguigeList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shangpinguige'],
            }),         
            //修改商品规格
            shangpinguigeUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/shangpinguigeUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shangpinguige'],
            }),         
            //新增商品订单
            shangpindingdanAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpindingdanAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpindingdan'],
            }),         
            //修改保存商品订单
            shangpindingdanUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpindingdanUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpindingdan'],
            }),         
            //查询商品订单
            shangpindingdanList: build.query({
                query(user) {                    
                    return {
                        url: '/shangpindingdanList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shangpindingdan'],
            }),         
            //修改商品订单
            shangpindingdanUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/shangpindingdanUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shangpindingdan'],
            }),         
            //新增商品教程
            shangpinjiaochengAdd: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpinjiaochengAdd',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpinjiaocheng'],
            }),         
            //修改保存商品教程
            shangpinjiaochengUpdateSave: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpinjiaochengUpdateSave',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpinjiaocheng'],
            }),         
            //查询商品教程
            shangpinjiaochengList: build.query({
                query(user) {                    
                    return {
                        url: '/shangpinjiaochengList',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shangpinjiaocheng'],
            }),         
            //修改商品教程
            shangpinjiaochengUpdate: build.query({
                query(user) {                    
                    return {
                        url: '/shangpinjiaochengUpdate',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                providesTags:['shangpinjiaocheng'],
            }),     
             //删除商品教程
            shangpinjiaochengDel: build.mutation({
                query(user) {                    
                    return {
                        url: '/shangpinjiaochengDel',
                        method: 'post',
                        body: form_data(user)
                    };                      
                },
                invalidatesTags:['shangpinjiaocheng'],
            }),            
        }
    }
})

export const { 
    useHangyeTypeAddMutation,
    useHangyeTypeListQuery,
    useHangyeTypeUpdateQuery,
    useHangyeTypeUpdateSaveMutation,
    useQiyeTypeAddMutation,
    useQiyeTypeListQuery,
    useQiyeTypeUpdateQuery,
    useQiyeTypeUpdateSaveMutation,
    useFyqiyeAddMutation,
    useFyqiyeUpdateSaveMutation,
    useFyqtQuery,
    useFyqiyeUpdateQuery,
    useFyyonghuAddMutation,
    useFyyonghuUpdateSaveMutation,
    useFyyonghuListQuery,
    useFyyonghuUpdateQuery,
    useFygetyonghuListQuery,
    useShangpinAddMutation,
    useShangpinUpdateSaveMutation,
    useShangpinListQuery,
    useShangpinUpdateQuery,
    useShangpinguigeAddMutation,
    useShangpinguigeUpdateSaveMutation,
    useShangpinguigeListQuery,
    useShangpinguigeUpdateQuery,
    useShangpindingdanAddMutation,
    useShangpindingdanUpdateSaveMutation,
    useShangpindingdanListQuery,
    useShangpindingdanUpdateQuery,
    useShangpinjiaochengAddMutation,
    useShangpinjiaochengDelMutation,
    useShangpinjiaochengListQuery,
    useShangpinjiaochengUpdateQuery,
    useShangpinjiaochengUpdateSaveMutation,
} = feiyongbaoxiaoApi;
export default feiyongbaoxiaoApi;